module.exports = __webpack_public_path__ + "static/media/10_Spades.61874387.svg";